import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ProductDetail',
  //   description: 'description of ProductDetail',
  //   url: '/product-detail',
  // },
];

export default help;
